import { render, staticRenderFns } from "./App.vue?vue&type=template&id=525394d9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../A8/pc/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5bba9927a18eaff02a55b79fc72fdde2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports